import React, { useState, useEffect } from 'react';
import { FaAngleUp } from 'react-icons/fa';
import styled from 'styled-components';

const StyledContainer = styled("div")`
position: fixed;
bottom: 15px;
right: 5px;
left: auto;
z-index: 999;
padding: 5px;

@media (max-width: 768px) {  // Adjust the screen size as per your needs
    display: none;
  }

.bring-to-top-button {
    background-color: #ffffff;
    border: none;
    border-radius: 100%;
    padding: 10px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

.bring-to-top-icon {
    color: gray;
    font-size: 24px;
  }
`

const BringtoTop = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setShowButton(scrollTop > 100); // we can change the value here
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <StyledContainer>
      {showButton && (
        <button
          className="bring-to-top-button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Bring to top"
        >
          <FaAngleUp className="bring-to-top-icon" />
        </button>
      )}
    </StyledContainer>
  );
}

export default BringtoTop;
